import { ErrorMessage, ErrorMessageProps } from 'formik';
import React from 'react';

const StyledErrorMessage: React.FC<ErrorMessageProps> = ({ className, ...props }) => {
  return (
    <ErrorMessage {...props}>
      {(msg) =>
        typeof msg === 'string' ? <div className={'text-red-600 ' + className}>{msg}</div> : null
      }
    </ErrorMessage>
  );
};

export default StyledErrorMessage;
